import "core-js/modules/es.array.filter";
import "core-js/modules/es.array.map";
import "core-js/modules/es.function.name";
import "core-js/modules/es.number.constructor";
import "core-js/modules/es.object.define-property";
import { __assign } from "tslib";
import Vue from 'vue';

var CityDetailModel =
/** @class */
function () {
  function CityDetailModel(detail) {
    var _this = this;

    this.id = null;
    this.name = '';
    /** 第几站 */

    this.index = 0;
    this.start_date = '';
    this.end_date = '';
    /** pending=玩呢，success=玩完，failed=没玩好 */

    this.status = 'pending';
    this.distance = 0;
    this.progress = 0;
    /** 已经完成的地标个数 */

    this.finish_landmark_count = 0;
    /** 线路背景图 */

    this.bg = '';
    /** 线路背景图宽 */

    this.bg_width = 0;
    /** 线路背景图高 */

    this.bg_height = 0;
    this.tips = '';
    this.landmarks = [];
    /** 是否前进过 */

    this.is_go = false;
    /** 坐标对应rotate */

    this.landmarkArrowMap = {};

    if (detail) {
      var distance = 0;
      this.id = detail.id;
      this.name = detail.name;
      this.index = detail.index;
      this.start_date = detail.start_date;
      this.end_date = detail.end_date;
      this.status = detail.status;
      this.distance = detail.distance;
      this.progress = Number(detail.progress);
      this.finish_landmark_count = detail.finish_landmark_count;
      this.bg = detail.bg;
      this.bg_width = detail.bg_width;
      this.bg_height = detail.bg_height;
      this.tips = detail.tips;
      this.is_go = detail.is_go;
      this.landmarks = detail.landmarks.map(function (ele, idx) {
        // distance += Number(ele.distance);
        var item = __assign(__assign({}, ele), {
          landmark_x: Number(ele.landmark_x),
          landmark_y: Number(ele.landmark_y),
          build_x: Number(ele.build_x),
          build_y: Number(ele.build_y),
          distance: Number(ele.distance)
        });

        var nextLandmark = detail.landmarks[idx + 1];
        var preLandmark = detail.landmarks[idx - 1];
        var x = item.landmark_x;
        var y = item.landmark_y;

        if (preLandmark) {
          var x1 = Number(preLandmark.landmark_x);
          var y1 = Number(preLandmark.landmark_y);

          if (x > x1) {
            Vue.set(_this.landmarkArrowMap, item.id, 180);
          } else {
            Vue.set(_this.landmarkArrowMap, item.id, 0);
          }
        } else if (idx === 0 && nextLandmark) {
          var x1 = Number(nextLandmark.landmark_x);
          var y1 = Number(nextLandmark.landmark_y);

          if (x < x1) {
            Vue.set(_this.landmarkArrowMap, item.id, 180);
          } else {
            Vue.set(_this.landmarkArrowMap, item.id, 0);
          }
        }

        return item;
      });
    }
  }

  Object.defineProperty(CityDetailModel.prototype, "landmarkIds", {
    get: function get() {
      return this.landmarks.map(function (ele) {
        return ele.id;
      });
    },
    enumerable: false,
    configurable: true
  });
  Object.defineProperty(CityDetailModel.prototype, "landmarkAll", {
    /** 所有地表点 */
    get: function get() {
      return this.landmarks.filter(function (landmark) {
        return landmark.type === 'landmark';
      });
    },
    enumerable: false,
    configurable: true
  });
  Object.defineProperty(CityDetailModel.prototype, "landmarkCount", {
    /** 地表数量 */
    get: function get() {
      return this.landmarkAll.length;
    },
    enumerable: false,
    configurable: true
  });
  Object.defineProperty(CityDetailModel.prototype, "turnAll", {
    /** 所有拐点 */
    get: function get() {
      return this.landmarks.filter(function (landmark) {
        return landmark.type === 'turn';
      });
    },
    enumerable: false,
    configurable: true
  });
  return CityDetailModel;
}();

export { CityDetailModel };